import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "fantasy-pick--em.firebaseapp.com",
  projectId: "fantasy-pick--em",
  storageBucket: "fantasy-pick--em.appspot.com",
  messagingSenderId: "1075943049193",
  appId: "1:1075943049193:web:41220f60ed052842052d78",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const provider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
  await signInWithPopup(auth, provider)
    .then((result) => {
      const email = result.user.email;
      const name = result.user.displayName;

      localStorage.setItem("name", name);
      localStorage.setItem("email", email);
    })
    .catch((error) => {
      const help = {
        'auth/unauthorized-domain': 'This local address is not authorized for Google sign-in. Try http://localhost:3000, or add this hostname in Firebase Authentication > Settings > Authorized domains.',
        'auth/popup-blocked': 'The browser blocked the Google sign-in window. Allow popups for this site, or open the local site in Chrome or Edge.',
        'auth/popup-closed-by-user': 'The Google sign-in window closed before sign-in finished. If it closes by itself, try the local site in Chrome or Edge.',
        'auth/cancelled-popup-request': 'Another sign-in attempt replaced this one. Try again with only one Google sign-in window open.',
      };
      throw new Error(help[error.code] || `Google sign-in failed (${error.code || 'unknown error'}). Please try again.`);
    });
};

export const db = getFirestore();
